import { render, staticRenderFns } from "./GiftcardPayment.vue?vue&type=template&id=5838ff54&scoped=true&"
import script from "./GiftcardPayment.vue?vue&type=script&lang=js&"
export * from "./GiftcardPayment.vue?vue&type=script&lang=js&"
import style0 from "./GiftcardPayment.vue?vue&type=style&index=0&id=5838ff54&scoped=true&lang=scss&"
import style1 from "./GiftcardPayment.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5838ff54",
  null
  
)

export default component.exports